<template>
  <div class="linear-scale">

    <ValidationProvider
      :vid="`linearscaletype${indexSection}${indexQuestion}`"
      name="Linear Scale"
      :rules="data.isRequired ? 'required' : ''"
      v-slot="{ errors }"
    >

      <div class="scale-container">

        <!-- LEFT SIDE LABEL -->
        <div class="left-label">
          {{ data.leftSide }}
        </div>

        <!-- SCALE ITEMS -->
        <div class="scale-items">

          <div
            v-for="number in scaleNumbers"
            :key="'item-'+number"
            class="scale-item"
          >
            <div class="scale-number">{{ number }}</div>
            <b-radio
              class="scale-radio"
              type="is-hcc"
              v-model="linearScale"
              :native-value="number"
            ></b-radio>
          </div>

        </div>

        <!-- RIGHT SIDE LABEL -->
        <div class="right-label">
          {{ data.rightSide }}
        </div>

      </div>

      <!-- ERROR -->
      <div class="required">
        {{ errors[0] }}
      </div>

      <info-storing-answer
        :question="data"
        @resend="$emit('resend-answer', data)"
      />

    </ValidationProvider>

  </div>
</template>

<script>
import InfoStoringAnswer from '@/components/V2/Candidat/InfoStoringAnswer.vue'
export default {
  components:{
    InfoStoringAnswer,
  },
  props: {
    data: {
      default: () => {},
    },
    indexSection: {
      default: () => {},
    },
    indexQuestion: {
      default: () => {},
    },
    sectionId: {
      default: () => {},
    },
  },
  data() {
    return {
      linearScale: null,
      isLoad: false,
    }
  },
  mounted() {
    this.init(this.data)
  },
  computed: {
    scaleNumbers() {
      const start = this.data.leftSideNumber
      const end = this.data.rightSideNumber
      const numbers = []
      for (let i = start; i <= end; i++) {
        numbers.push(i)
      }
      return numbers
    }
  },
  watch: {
    data(val){
      this.linearScale = null
      this.init(val)
    },
    linearScale() {
      if (!this.isLoad) {
        this.submit()
      } else {
        this.isLoad = false
      }
    },
  },
  methods: {
    init(data){
      this.isLoad = true
      this.linearScale =
        data.answerList[0].description == null
          ? null
          : parseInt(data.answerList[0].description)
      if (this.linearScale == null) {
        this.isLoad = false
      }
    },
    submit() {
      let data = {
        newSectionId: this.sectionId,
        newQuestionId: this.data.id,
        newAnswerId: this.data.answerList[0].id,
        description: null,
        rating: this.linearScale,
        indexQuestion: 0,
        indexAnswer: 0,
      }

      this.$emit('clicked', data)
    },
    resetAnswer(){
      this.linearScale = null
    }
  },
}
</script>

<style scoped>
.linear-scale {
  width: 100%;
}

.scale-container {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
}

/* Desktop */
.left-label,
.right-label {
  width: 10%;
  text-align: center;
  margin-top: 8px;
}

.scale-items {
  width: 80%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: nowrap;
}

.scale-item {
  text-align: center;
  min-width: 44px;
}

.scale-number {
  margin-bottom: 4px;
}

.scale-radio {
  display: flex;
  justify-content: center;
  padding: 8px;
}

/* MOBILE */
@media screen and (max-width: 768px) {
  .scale-container {
    flex-direction: column;
    align-items: flex-start;
  }

  .left-label,
  .right-label {
    width: 100%;
    text-align: left;
    margin-bottom: 8px;
  }

  .scale-items {
    width: 100%;
    display: flex;
    flex-direction: column;
  }

  .scale-item {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 6px;
  }

  .scale-number {
    width: 20px;
    margin-right: 12px;
  }
}
</style>
